import {Dashboard} from "@/components";
import {Friends} from "@/components";

export const FriendsPage = () => (
  <Dashboard openLogIn>
    <Friends />
  </Dashboard>
)